export default __webpack_public_path__ + "static/media/ROLLER JAM ACCIDENT SIMULATOR.9ce9f3fe.JPG";